"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEventType = exports.VERSION = exports.TOPIC_MAPPING = exports.Topic = void 0;
const t = __importStar(require("io-ts"));
const toggle_1 = require("./app/toggle");
const refresh_1 = require("./app/refresh");
const switch_url_1 = require("./app/switch.url");
const knowledge_view_1 = require("./app/knowledge.view");
const section_view_1 = require("./app/section.view");
const toast_close_1 = require("./app/toast.close");
const toast_close_all_1 = require("./app/toast.close.all");
const toast_receive_1 = require("./app/toast.receive");
const login_success_1 = require("./app/login.success");
const login_failure_1 = require("./app/login.failure");
const logout_1 = require("./app/logout");
const bug_tracking_1 = require("./app/bug.tracking");
const login_failure_2 = require("./auth/login.failure");
const login_success_2 = require("./auth/login.success");
const provisioning_success_1 = require("./auth/provisioning.success");
const archive_1 = require("./content/archive");
const create_1 = require("./content/create");
const favorite_add_1 = require("./content/favorite.add");
const favorite_remove_1 = require("./content/favorite.remove");
const feedback_1 = require("./content/feedback");
const read_1 = require("./content/read");
const satisfaction_1 = require("./content/satisfaction");
const search_1 = require("./content/search");
const search_abort_1 = require("./content/search.abort");
const search_success_1 = require("./content/search.success");
const recommendation_success_1 = require("./content/recommendation.success");
const recommendation_abort_1 = require("./content/recommendation.abort");
const recommendation_receive_1 = require("./content/recommendation.receive");
const copy_1 = require("./content/copy");
const meta_view_1 = require("./content/meta.view");
const verificationPolicy_1 = require("./content/verificationPolicy");
const contribution_1 = require("./general/contribution");
const feedback_2 = require("./general/feedback");
const notification_1 = require("./general/notification");
const integration_add_1 = require("./company/integration.add");
const integration_remove_1 = require("./company/integration.remove");
const read_2 = require("./product/read");
const invitation_register_1 = require("./user/invitation.register");
const invitation_delete_1 = require("./user/invitation.delete");
const invitation_1 = require("./user/invitation");
const invitation_renew_1 = require("./user/invitation.renew");
const content_1 = require("./ticket/content");
const update_1 = require("./task/update");
const reaction_1 = require("./task/reaction");
const status_1 = require("./task/status");
const read_3 = require("./notification/read");
const read_all_1 = require("./notification/read.all");
const comment_1 = require("./notification/comment");
const receive_1 = require("./notification/receive");
const agentNew_start_1 = require("./notification/agentNew.start");
const agentNew_messageAndOptions_1 = require("./notification/agentNew.messageAndOptions");
const agentNew_assignedUsers_1 = require("./notification/agentNew.assignedUsers");
const agentNew_sent_1 = require("./notification/agentNew.sent");
const agentNotification_view_1 = require("./notification/agentNotification.view");
const agentNotification_delete_1 = require("./notification/agentNotification.delete");
const agentNotification_edit_1 = require("./notification/agentNotification.edit");
const agentNotification_toggleVisibility_1 = require("./notification/agentNotification.toggleVisibility");
const agentNotification_relaunch_1 = require("./notification/agentNotification.relaunch");
const agentNotification_searchFilters_1 = require("./notification/agentNotification.searchFilters");
const agentNotification_data_export_1 = require("./notification/agentNotification.data.export");
const agentNotification_data_read_1 = require("./notification/agentNotification.data.read");
const hub_card_view_1 = require("./task/hub.card.view");
const comment_2 = require("./feedback/comment");
const content_read_1 = require("./public/content.read");
const case_read_1 = require("./public/case.read");
const content_satisfaction_1 = require("./public/content.satisfaction");
const content_feedback_1 = require("./public/content.feedback");
const content_search_1 = require("./public/content.search");
const content_search_success_1 = require("./public/content.search.success");
const content_search_abort_1 = require("./public/content.search.abort");
const knowledge_read_1 = require("./public/knowledge.read");
const content_get_success_1 = require("./public/api/content.get.success");
const search_success_2 = require("./public/api/search.success");
const search_failure_1 = require("./public/api/search.failure");
const answer_1 = require("./public/ask/answer");
const copyAnswer_1 = require("./public/ask/copyAnswer");
const error_1 = require("./public/ask/error");
const feedback_3 = require("./public/ask/feedback");
const question_1 = require("./public/ask/question");
const useSource_1 = require("./public/ask/useSource");
const openModal_1 = require("./public/ask/openModal");
const message_create_1 = require("./thread/message.create");
const message_edit_1 = require("./thread/message.edit");
const message_delete_1 = require("./thread/message.delete");
const message_vote_1 = require("./thread/message.vote");
const status_2 = require("./thread/status");
const shortcut_1 = require("./slack/shortcut");
const modal_action_1 = require("./slack/modal.action");
const preference_add_1 = require("./settings/preference.add");
const preference_remove_1 = require("./settings/preference.remove");
const language_1 = require("./settings/language");
const public_add_1 = require("./settings/public.add");
const public_update_1 = require("./settings/public.update");
const public_remove_1 = require("./settings/public.remove");
const public_deployment_start_1 = require("./settings/public.deployment.start");
const question_2 = require("./ask/question");
const answer_2 = require("./ask/answer");
const error_2 = require("./ask/error");
const useSource_2 = require("./ask/useSource");
const public_login_success_1 = require("./auth/public.login.success");
const published_update_1 = require("./content/published.update");
const isOutdated_update_1 = require("./content/isOutdated.update");
const alerts_1 = require("./obsolescence/alerts");
const feedback_4 = require("./ask/feedback");
const copyAnswer_2 = require("./ask/copyAnswer");
const language_switch_1 = require("./app/language.switch");
const function_performance_1 = require("./context/function.performance");
const function_error_1 = require("./context/function.error");
const login_success_3 = require("./public/login.success");
const login_failure_3 = require("./public/login.failure");
const module_view_1 = require("./academy/module.view");
const module_start_1 = require("./academy/module.start");
const module_resume_1 = require("./academy/module.resume");
const module_complete_1 = require("./academy/module.complete");
const slide_view_1 = require("./academy/slide.view");
const slide_next_1 = require("./academy/slide.next");
const module_search_1 = require("./academy/module.search");
const question_answer_1 = require("./academy/question.answer");
const correction_view_1 = require("./academy/correction.view");
const module_satisfaction_1 = require("./academy/module.satisfaction");
const feedback_5 = require("./academy/feedback");
const analytics_view_1 = require("./academy/analytics.view");
const analytics_filters_1 = require("./academy/analytics.filters");
const analytics_export_1 = require("./academy/analytics.export");
const workflowAction_create_1 = require("./content/workflowAction.create");
const workflowAction_update_1 = require("./content/workflowAction.update");
const workflowAction_delete_1 = require("./content/workflowAction.delete");
const workflowActionLibrary_create_1 = require("./workflowActionLibrary/workflowActionLibrary.create");
const workflowActionLibrary_update_1 = require("./workflowActionLibrary/workflowActionLibrary.update");
const workflowAction_order_1 = require("./content/workflowAction.order");
const close_1 = require("./copilot/close");
const open_1 = require("./copilot/open");
const copy_ticketId_1 = require("./copilot/copy.ticketId");
const goto_feedback_1 = require("./copilot/goto.feedback");
const goto_search_1 = require("./copilot/goto.search");
const toast_open_1 = require("./copilot/toast.open");
const toast_receive_2 = require("./copilot/toast.receive");
const use_automation_1 = require("./copilot/use.automation");
const automation_receive_1 = require("./copilot/automation.receive");
const automation_brain_receive_1 = require("./copilot/automation.brain.receive");
const custom_1 = require("./feedback/custom");
const externalLink_1 = require("./public/ask/externalLink");
const archive_delete_1 = require("./archives/archive.delete");
const archive_restore_1 = require("./archives/archive.restore");
const archive_filter_1 = require("./archives/archive.filter");
const creation_trigger_1 = require("./version/creation.trigger");
const creation_review_1 = require("./version/creation.review");
const creation_done_1 = require("./version/creation.done");
const creation_open_modal_1 = require("./version/creation.open.modal");
const update_available_1 = require("./version/update.available");
const update_hide_banner_1 = require("./version/update.hide.banner");
const update_open_modal_1 = require("./version/update.open.modal");
const update_trigger_1 = require("./version/update.trigger");
const access_settings_ai_1 = require("./askCustomAssistant/access.settings.ai");
const access_settings_ask_1 = require("./askCustomAssistant/access.settings.ask");
const create_2 = require("./askCustomAssistant/create");
const trigger_configure_1 = require("./askCustomAssistant/trigger.configure");
const trigger_edit_1 = require("./askCustomAssistant/trigger.edit");
const trigger_start_1 = require("./askCustomAssistant/trigger.start");
const trigger_tester_1 = require("./askCustomAssistant/trigger.tester");
const update_2 = require("./askCustomAssistant/update");
//HUB
const open_2 = require("./hub/archive/open");
const close_2 = require("./hub/archive/close");
const open_3 = require("./hub/task/open");
const close_3 = require("./hub/task/close");
const archive_2 = require("./hub/task/archive");
const restore_1 = require("./hub/task/restore");
const status_3 = require("./hub/task/properties/status");
const add_1 = require("./hub/task/upvote/add");
const remove_1 = require("./hub/task/upvote/remove");
const update_3 = require("./hub/task/rating/update");
const remove_2 = require("./hub/task/rating/remove");
const assignee_1 = require("./hub/task/properties/assignee");
const priority_update_1 = require("./hub/task/properties/priority.update");
const priority_remove_1 = require("./hub/task/properties/priority.remove");
const deadline_update_1 = require("./hub/task/properties/deadline.update");
const deadline_remove_1 = require("./hub/task/properties/deadline.remove");
const add_2 = require("./hub/task/comment/add");
const remove_3 = require("./hub/task/comment/remove");
const update_4 = require("./hub/task/comment/update");
const select_1 = require("./hub/view/select");
const search_2 = require("./hub/filters/search");
const update_5 = require("./hub/filters/update");
const reset_1 = require("./hub/filters/reset");
const admin_section_view_1 = require("./app/admin.section.view");
const session_workflowAction_1 = require("./context/session.workflowAction");
const create_3 = require("./case/create");
const cancel_suggestion_1 = require("./aiEditorAssist/cancel.suggestion");
const trigger_1 = require("./aiEditorAssist/trigger");
const use_suggestion_1 = require("./aiEditorAssist/use.suggestion");
var Topic;
(function (Topic) {
    Topic["APP_TOGGLE"] = "app.toggle";
    Topic["APP_REFRESH"] = "app.refresh";
    Topic["APP_SWITCH_URL"] = "app.switch.url";
    Topic["APP_SECTION_VIEW"] = "app.section.view";
    Topic["APP_KNOWLEDGE_VIEW"] = "app.knowledge.view";
    Topic["APP_ADMIN_SECTION_VIEW"] = "app.admin.section.view";
    Topic["APP_TOAST_CLOSE"] = "app.toast.close";
    Topic["APP_TOAST_CLOSE_ALL"] = "app.toast.close.all";
    Topic["APP_TOAST_RECEIVE"] = "app.toast.receive";
    Topic["APP_LOGIN_SUCCESS"] = "app.login.success";
    Topic["APP_LOGIN_FAILURE"] = "app.login.failure";
    Topic["APP_LOGOUT"] = "app.logout";
    Topic["APP_BUG_TRACKING"] = "app.bug.tracking";
    Topic["AUTH_LOGIN_FAILURE"] = "auth.login.failure";
    Topic["AUTH_LOGIN_SUCCESS"] = "auth.login.success";
    Topic["AUTH_PROVISIONING_SUCCESS"] = "auth.provisioning.success";
    Topic["AUTH_PUBLIC_LOGIN_SUCCESS"] = "auth.public.login.success";
    Topic["CONTENT_ARCHIVE"] = "content.archive";
    Topic["CONTENT_CREATE"] = "content.create";
    Topic["CONTENT_FAVORITE_ADD"] = "content.favorite.add";
    Topic["CONTENT_FAVORITE_REMOVE"] = "content.favorite.remove";
    Topic["CONTENT_FEEDBACK"] = "content.feedback";
    Topic["CONTENT_READ"] = "content.read";
    Topic["CONTENT_SATISFACTION"] = "content.satisfaction";
    Topic["CONTENT_SEARCH_ABORT"] = "content.search.abort";
    Topic["CONTENT_SEARCH_SUCCESS"] = "content.search.success";
    Topic["CONTENT_SEARCH"] = "content.search";
    Topic["CONTENT_RECOMMENDATION_SUCCESS"] = "content.recommendation.success";
    Topic["CONTENT_RECOMMENDATION_ABORT"] = "content.recommendation.abort";
    Topic["CONTENT_RECOMMENDATION_RECEIVE"] = "content.recommendation.receive";
    Topic["CONTENT_COPY"] = "content.copy";
    Topic["CONTENT_META_VIEW"] = "content.meta.view";
    Topic["CONTENT_VERIFICATION_POLICY_ADD"] = "content.verificationPolicy.add";
    Topic["CONTENT_VERIFICATION_POLICY_REMOVE"] = "content.verificationPolicy.remove";
    Topic["CONTENT_VERIFICATION_POLICY_UPDATE"] = "content.verificationPolicy.update";
    Topic["CONTENT_PUBLISHED_UPDATE"] = "content.published.update";
    Topic["CONTENT_IS_OUTDATED_UPDATE"] = "content.isOutdated.update";
    Topic["CONTENT_WORKFLOW_ACTION_CREATE"] = "content.workflowAction.create";
    Topic["CONTENT_WORKFLOW_ACTION_UPDATE"] = "content.workflowAction.update";
    Topic["CONTENT_WORKFLOW_ACTION_DELETE"] = "content.workflowAction.delete";
    Topic["CONTENT_WORKFLOW_ACTION_ORDER"] = "content.workflowAction.order";
    Topic["CASE_CREATE"] = "case.create";
    Topic["WORKFLOW_ACTION_LIBRARY_CREATE"] = "workflowActionLibrary.create";
    Topic["WORKFLOW_ACTION_LIBRARY_UPDATE"] = "workflowActionLibrary.update";
    Topic["GENERAL_CONTRIBUTION"] = "general.contribution";
    Topic["GENERAL_FEEDBACK"] = "general.feedback";
    Topic["GENERAL_NOTIFICATION"] = "general.notification";
    Topic["COMPANY_INTEGRATION_ADD"] = "company.integration.add";
    Topic["COMPANY_INTEGRATION_REMOVE"] = "company.integration.remove";
    Topic["PRODUCT_READ"] = "product.read";
    Topic["USER_INVITATION_REGISTER"] = "user.register";
    Topic["USER_DELETE"] = "user.delete";
    Topic["USER_INVITATION"] = "user.invitation";
    Topic["USER_INVITATION_RENEW"] = "user.invitation.renew";
    Topic["TICKET_CONTENT"] = "ticket.content";
    Topic["TASK_UPDATE"] = "task.update";
    Topic["TASK_REACTION"] = "task.reaction";
    Topic["TASK_STATUS"] = "task.status";
    Topic["NOTIFICATION_READ"] = "notification.read";
    Topic["NOTIFICATION_READ_ALL"] = "notification.read.all";
    Topic["NOTIFICATION_COMMENT"] = "notification.comment";
    Topic["NOTIFICATION_RECEIVE"] = "notification.receive";
    Topic["NOTIFICATION_AGENT_NEW_START"] = "notification.agent-new.start";
    Topic["NOTIFICATION_AGENT_NEW_MESSAGE_AND_OPTIONS"] = "notification.agent-new.message-and-options";
    Topic["NOTIFICATION_AGENT_NEW_ASSIGNED_USERS"] = "notification.agent-new.assigned-users";
    Topic["NOTIFICATION_AGENT_NEW_SENT"] = "notification.agent-new.sent";
    Topic["NOTIFICATION_AGENT_VIEW"] = "notification.agent.view";
    Topic["NOTIFICATION_AGENT_DELETE"] = "notification.agent.delete";
    Topic["NOTIFICATION_AGENT_EDIT"] = "notification.agent.edit";
    Topic["NOTIFICATION_AGENT_TOGGLE_VISIBILITY"] = "notification.agent.toggleVisibility";
    Topic["NOTIFICATION_AGENT_RELAUNCH"] = "notification.agent.relaunch";
    Topic["NOTIFICATION_AGENT_SEARCH_FILTERS"] = "notification.agent.searchFilters";
    Topic["NOTIFICATION_AGENT_DATA_EXPORT"] = "notification.agent.data.export";
    Topic["NOTIFICATION_AGENT_DATA_READ"] = "notification.agent.data.read";
    Topic["HUB_CARD_VIEW"] = "hub.card.view";
    Topic["FEEDBACK_COMMENT"] = "feedback.comment";
    Topic["PUBLIC_CONTENT_READ"] = "public.content.read";
    Topic["PUBLIC_CASE_READ"] = "public.case.read";
    Topic["PUBLIC_CONTENT_SATISFACTION"] = "public.content.satisfaction";
    Topic["PUBLIC_CONTENT_FEEDBACK"] = "public.content.feedback";
    Topic["PUBLIC_CONTENT_SEARCH"] = "public.content.search";
    Topic["PUBLIC_CONTENT_SEARCH_SUCCESS"] = "public.content.search.success";
    Topic["PUBLIC_CONTENT_SEARCH_ABORT"] = "public.content.search.abort";
    Topic["PUBLIC_KNOWLEDGE_READ"] = "public.knowledge.read";
    Topic["PUBLIC_API_CONTENT_GET_SUCCESS"] = "public.content.get.success";
    Topic["PUBLIC_API_SEARCH_SUCCESS"] = "public.api.search.success";
    Topic["PUBLIC_API_SEARCH_FAILURE"] = "public.api.search.failure";
    Topic["THREAD_MESSAGE_CREATE"] = "thread.message.create";
    Topic["THREAD_MESSAGE_EDIT"] = "thread.message.edit";
    Topic["THREAD_MESSAGE_DELETE"] = "thread.message.delete";
    Topic["THREAD_MESSAGE_VOTE"] = "thread.message.vote";
    Topic["THREAD_STATUS"] = "thread.status";
    Topic["SLACK_SHORTCUT"] = "slack.shortcut";
    Topic["SLACK_MODAL_ACTION"] = "slack.modal.action";
    Topic["SETTINGS_ADD"] = "settings.add";
    Topic["SETTINGS_REMOVE"] = "settings.remove";
    Topic["SETTINGS_LANGUAGE"] = "settings.language";
    Topic["PUBLIC_SETTINGS_ADD"] = "public.settings.add";
    Topic["PUBLIC_SETTINGS_UPDATE"] = "public.settings.update";
    Topic["PUBLIC_SETTINGS_REMOVE"] = "public.settings.remove";
    Topic["PUBLIC_SETTINGS_DEPLOYMENT_START"] = "public.settings.deployment.start";
    Topic["ASK_QUESTION"] = "ask.question";
    Topic["ASK_ANSWER"] = "ask.answer";
    Topic["ASK_ERROR"] = "ask.error";
    Topic["ASK_USE_SOURCE"] = "ask.use.source";
    Topic["ASK_FEEDBACK"] = "ask.feedback";
    Topic["ASK_COPY_ANSWER"] = "ask.copy.answer";
    Topic["PUBLIC_ASK_QUESTION"] = "public.ask.question";
    Topic["PUBLIC_ASK_ANSWER"] = "public.ask.answer";
    Topic["PUBLIC_ASK_ERROR"] = "public.ask.error";
    Topic["PUBLIC_ASK_USE_SOURCE"] = "public.ask.use.source";
    Topic["PUBLIC_ASK_FEEDBACK"] = "public.ask.feedback";
    Topic["PUBLIC_ASK_COPY_ANSWER"] = "public.ask.copy.answer";
    Topic["PUBLIC_ASK_OPEN_MODAL"] = "public.ask.open.modal";
    Topic["PUBLIC_ASK_CLICK_EXTERNAL_LINK"] = "public.ask.click.external-link";
    Topic["OBSOLESCENCE_ALERTS"] = "obsolescence.alerts";
    Topic["LANGUAGE_SWITCH"] = "language.switch";
    Topic["CONTEXT_FUNCTION_PERFORMANCE"] = "context.function.performance";
    Topic["CONTEXT_FUNCTION_ERROR"] = "context.function.error";
    Topic["PUBLIC_LOGIN_SUCCESS"] = "public.login.success";
    Topic["PUBLIC_LOGIN_FAILURE"] = "public.login.failure";
    Topic["CUSTOM_FEEDBACK"] = "feedback.custom";
    // ACADEMY
    Topic["ACADEMY_MODULE_VIEW"] = "academy.module.view";
    Topic["ACADEMY_MODULE_SEARCH"] = "academy.module.search";
    Topic["ACADEMY_MODULE_START"] = "academy.module.start";
    Topic["ACADEMY_MODULE_RESUME"] = "academy.module.resume";
    Topic["ACADEMY_MODULE_COMPLETE"] = "academy.module.complete";
    Topic["ACADEMY_SLIDE_VIEW"] = "academy.slide.view";
    Topic["ACADEMY_SLIDE_NEXT"] = "academy.slide.next";
    Topic["ACADEMY_QUESTION_ANSWER"] = "academy.question.answer";
    Topic["ACADEMY_CORRECTION_VIEW"] = "academy.correction.view";
    Topic["ACADEMY_MODULE_SATISFACTION"] = "academy.module.satisfaction";
    Topic["ACADEMY_FEEDBACK"] = "academy.feedback";
    Topic["ACADEMY_ANALYTICS_VIEW"] = "academy.analytics.view";
    Topic["ACADEMY_ANALYTICS_FILTERS"] = "academy.analytics.filters";
    Topic["ACADEMY_ANALYTICS_EXPORT"] = "academy.analytics.export";
    //COPILOT
    Topic["COPILOT_OPEN"] = "copilot.open";
    Topic["COPILOT_CLOSE"] = "copilot.close";
    Topic["COPILOT_TOAST_OPEN"] = "copilot.toast.open";
    Topic["COPILOT_TOAST_RECEIVE"] = "copilot.toast.receive";
    Topic["COPILOT_GOTO_FEEDBACK"] = "copilot.goto.feedback";
    Topic["COPILOT_GOTO_SEARCH"] = "copilot.goto.search";
    Topic["COPILOT_COPY_TICKET_ID"] = "copilot.copy.ticketId";
    Topic["COPILOT_USE_AUTOMATION"] = "copilot.use.automation";
    Topic["COPILOT_AUTOMATION_RECEIVE"] = "copilot.automation.receive";
    Topic["COPILOT_AUTOMATION_BRAIN_RECEIVE"] = "copilot.automation.brain.receive";
    //ARCHIVES
    Topic["ARCHIVE_DELETED"] = "archive.delete";
    Topic["ARCHIVE_RESTORED"] = "archive.restore";
    Topic["ARCHIVE_FILTERED"] = "archive.filter";
    //VERSION
    Topic["VERSION_CREATE_DONE"] = "version.create.done";
    Topic["VERSION_CREATE_REVIEW"] = "version.create.review";
    Topic["VERSION_CREATE_TRIGGER"] = "version.create.trigger";
    Topic["VERSION_CREATE_OPEN_MODAL"] = "version.create.open.modal";
    Topic["VERSION_UPDATE_AVAILABLE"] = "version.update.available";
    Topic["VERSION_UPDATE_OPEN_MODAL"] = "version.update.open.modal";
    Topic["VERSION_UPDATE_TRIGGER"] = "version.update.trigger";
    Topic["VERSION_UPDATE_HIDE_BANNER"] = "version.update.hide.banner";
    // ASK CUSTOM ASSISTANT
    Topic["ASK_CUSTOM_ASSISTANT_ACCESS_SETTINGS_AI"] = "askCustomAssistant.access.settings.ai";
    Topic["ASK_CUSTOM_ASSISTANT_ACCESS_SETTINGS_ASK"] = "askCustomAssistant.access.settings.ask";
    Topic["ASK_CUSTOM_ASSISTANT_CREATE"] = "askCustomAssistant.create";
    Topic["ASK_CUSTOM_ASSISTANT_UPDATE"] = "askCustomAssistant.update";
    Topic["ASK_CUSTOM_ASSISTANT_TRIGGER_CONFIGURE"] = "askCustomAssistant.trigger.configure";
    Topic["ASK_CUSTOM_ASSISTANT_TRIGGER_EDIT"] = "askCustomAssistant.trigger.edit";
    Topic["ASK_CUSTOM_ASSISTANT_TRIGGER_START"] = "askCustomAssistant.trigger.start";
    Topic["ASK_CUSTOM_ASSISTANT_TRIGGER_TESTER"] = "askCustomAssistant.trigger.tester";
    // HUB
    Topic["HUB_ARCHIVE_OPEN"] = "hub.archive.open";
    Topic["HUB_ARCHIVE_CLOSE"] = "hub.archive.close";
    Topic["HUB_TASK_OPEN"] = "hub.task.open";
    Topic["HUB_TASK_CLOSE"] = "hub.task.close";
    Topic["HUB_TASK_ARCHIVE"] = "hub.task.archive";
    Topic["HUB_TASK_RESTORE"] = "hub.task.restore";
    Topic["HUB_TASK_STATUS"] = "hub.task.properties.status";
    Topic["HUB_TASK_UPVOTE_ADD"] = "hub.task.upvote.add";
    Topic["HUB_TASK_UPVOTE_REMOVE"] = "hub.task.upvote.remove";
    Topic["HUB_TASK_RATING_UPDATE"] = "hub.task.rating.add";
    Topic["HUB_TASK_RATING_REMOVE"] = "hub.task.rating.remove";
    Topic["HUB_TASK_ASSIGNEE"] = "hub.task.properties.assignee";
    Topic["HUB_TASK_PRIORITY_UPDATE"] = "hub.task.properties.priority.update";
    Topic["HUB_TASK_PRIORITY_REMOVE"] = "hub.task.properties.priority.remove";
    Topic["HUB_TASK_DEADLINE_UPDATE"] = "hub.task.properties.deadline.update";
    Topic["HUB_TASK_DEADLINE_REMOVE"] = "hub.task.properties.deadline.remove";
    Topic["HUB_TASK_COMMENT_ADD"] = "hub.task.comment.add";
    Topic["HUB_TASK_COMMENT_REMOVE"] = "hub.task.comment.remove";
    Topic["HUB_TASK_COMMENT_UPDATE"] = "hub.task.comment.update";
    Topic["HUB_VIEW_SELECT"] = "hub.view.select";
    Topic["HUB_FILTERS_SEARCH"] = "hub.filters.search";
    Topic["HUB_FILTERS_UPDATE"] = "hub.filters.update";
    Topic["HUB_FILTERS_RESET"] = "hub.filters.reset";
    // SESSION
    Topic["CONTEXT_SESSION_WORKFLOW_ACTION"] = "context.session.workflowAction";
    // AI EDITOR ASSIST
    Topic["AI_EDITOR_ASSIST_TRIGGER"] = "aiEditorAssist.trigger";
    Topic["AI_EDITOR_ASSIST_USE_SUGGESTION"] = "aiEditorAssist.use.suggestion";
    Topic["AI_EDITOR_ASSIST_CANCEL_SUGGESTION"] = "aiEditorAssist.cancel.suggestion";
})(Topic = exports.Topic || (exports.Topic = {}));
//ajouter ici aussi nom => fichier
exports.TOPIC_MAPPING = {
    [Topic.APP_TOGGLE]: toggle_1.AppToggleEventType,
    [Topic.APP_REFRESH]: refresh_1.AppRefreshEventType,
    [Topic.APP_SWITCH_URL]: switch_url_1.AppSwitchUrlEventType,
    [Topic.APP_SECTION_VIEW]: section_view_1.AppSectionViewEventType,
    [Topic.APP_ADMIN_SECTION_VIEW]: admin_section_view_1.AppAdminSectionViewEventType,
    [Topic.APP_KNOWLEDGE_VIEW]: knowledge_view_1.AppKnowledgeViewEventType,
    [Topic.APP_TOAST_CLOSE]: toast_close_1.AppToastCloseEventType,
    [Topic.APP_TOAST_CLOSE_ALL]: toast_close_all_1.AppToastCloseAllEventType,
    [Topic.APP_TOAST_RECEIVE]: toast_receive_1.AppToastReceiveEventType,
    [Topic.APP_LOGIN_SUCCESS]: login_success_1.AppLoginSuccessEventType,
    [Topic.APP_LOGIN_FAILURE]: login_failure_1.AppLoginFailureEventType,
    [Topic.APP_LOGOUT]: logout_1.AppLogoutEventType,
    [Topic.APP_BUG_TRACKING]: bug_tracking_1.AppBugTrackingEventType,
    [Topic.AUTH_LOGIN_FAILURE]: login_failure_2.AuthLoginFailureEventType,
    [Topic.AUTH_LOGIN_SUCCESS]: login_success_2.AuthLoginSuccessEventType,
    [Topic.AUTH_PROVISIONING_SUCCESS]: provisioning_success_1.AuthProvisioningSuccessEventType,
    [Topic.AUTH_PUBLIC_LOGIN_SUCCESS]: public_login_success_1.AuthPublicLoginSuccessEventType,
    [Topic.CONTENT_ARCHIVE]: archive_1.ContentArchiveEventType,
    [Topic.CONTENT_CREATE]: create_1.ContentCreateEventType,
    [Topic.CONTENT_FAVORITE_ADD]: favorite_add_1.ContentFavoriteAddEventType,
    [Topic.CONTENT_FAVORITE_REMOVE]: favorite_remove_1.ContentFavoriteRemoveEventType,
    [Topic.CONTENT_FEEDBACK]: feedback_1.ContentFeedbackEventType,
    [Topic.CONTENT_READ]: read_1.ContentReadEventType,
    [Topic.CONTENT_SATISFACTION]: satisfaction_1.ContentSatisfactionEventType,
    [Topic.CONTENT_SEARCH_ABORT]: search_abort_1.ContentSearchAbortEventType,
    [Topic.CONTENT_SEARCH_SUCCESS]: search_success_1.ContentSearchSuccessEventType,
    [Topic.CONTENT_RECOMMENDATION_SUCCESS]: recommendation_success_1.ContentRecommendationSuccessEventType,
    [Topic.CONTENT_RECOMMENDATION_ABORT]: recommendation_abort_1.ContentRecommendationAbortEventType,
    [Topic.CONTENT_RECOMMENDATION_RECEIVE]: recommendation_receive_1.ContentRecommendationReceiveEventType,
    [Topic.CONTENT_SEARCH]: search_1.ContentSearchEventType,
    [Topic.CONTENT_COPY]: copy_1.ContentCopyEventType,
    [Topic.CONTENT_META_VIEW]: meta_view_1.ContentMetaViewEventType,
    [Topic.CONTENT_VERIFICATION_POLICY_ADD]: verificationPolicy_1.ContentVerificationPolicyAddEventType,
    [Topic.CONTENT_VERIFICATION_POLICY_REMOVE]: verificationPolicy_1.ContentVerificationPolicyRemoveEventType,
    [Topic.CONTENT_VERIFICATION_POLICY_UPDATE]: verificationPolicy_1.ContentVerificationPolicyUpdateEventType,
    [Topic.CONTENT_PUBLISHED_UPDATE]: published_update_1.ContentPublishedEventType,
    [Topic.CONTENT_IS_OUTDATED_UPDATE]: isOutdated_update_1.ContentIsOutdatedEventType,
    [Topic.CONTENT_WORKFLOW_ACTION_CREATE]: workflowAction_create_1.WorkflowActionCreateEventType,
    [Topic.CONTENT_WORKFLOW_ACTION_UPDATE]: workflowAction_update_1.WorkflowActionUpdateEventType,
    [Topic.CONTENT_WORKFLOW_ACTION_DELETE]: workflowAction_delete_1.WorkflowActionDeleteEventType,
    [Topic.CONTENT_WORKFLOW_ACTION_ORDER]: workflowAction_order_1.WorkflowActionOrderEventType,
    [Topic.CASE_CREATE]: create_3.CaseCreateEventType,
    [Topic.WORKFLOW_ACTION_LIBRARY_CREATE]: workflowActionLibrary_create_1.WorkflowActionLibraryCreateEventType,
    [Topic.WORKFLOW_ACTION_LIBRARY_UPDATE]: workflowActionLibrary_update_1.WorkflowActionLibraryUpdateEventType,
    [Topic.GENERAL_CONTRIBUTION]: contribution_1.GeneralContributionEventType,
    [Topic.GENERAL_FEEDBACK]: feedback_2.GeneralFeedbackEventType,
    [Topic.GENERAL_NOTIFICATION]: notification_1.GeneralNotificationEventType,
    [Topic.COMPANY_INTEGRATION_ADD]: integration_add_1.CompanyIntegrationAddEventType,
    [Topic.COMPANY_INTEGRATION_REMOVE]: integration_remove_1.CompanyIntegrationRemoveEventType,
    [Topic.PRODUCT_READ]: read_2.ProductReadEventType,
    [Topic.USER_INVITATION_REGISTER]: invitation_register_1.UserRegisterEventType,
    [Topic.USER_DELETE]: invitation_delete_1.UserDeleteEventType,
    [Topic.USER_INVITATION]: invitation_1.UserInvitationEventType,
    [Topic.USER_INVITATION_RENEW]: invitation_renew_1.UserInvitationRenewEventType,
    [Topic.TICKET_CONTENT]: content_1.TicketContentEventType,
    [Topic.TASK_UPDATE]: update_1.TaskUpdateEventType,
    [Topic.TASK_REACTION]: reaction_1.TaskReactionEventType,
    [Topic.TASK_STATUS]: status_1.TaskStatusEventType,
    [Topic.NOTIFICATION_READ]: read_3.NotificationReadEventType,
    [Topic.NOTIFICATION_READ_ALL]: read_all_1.NotificationReadAllEventType,
    [Topic.NOTIFICATION_COMMENT]: comment_1.NotificationCommentEventType,
    [Topic.NOTIFICATION_RECEIVE]: receive_1.NotificationReceiveEventType,
    [Topic.NOTIFICATION_AGENT_NEW_START]: agentNew_start_1.NotificationAgentNewStartEventType,
    [Topic.NOTIFICATION_AGENT_NEW_MESSAGE_AND_OPTIONS]: agentNew_messageAndOptions_1.NotificationAgentNewMessageAndOptionsEventType,
    [Topic.NOTIFICATION_AGENT_NEW_ASSIGNED_USERS]: agentNew_assignedUsers_1.NotificationAgentNewAssignedUsersEventType,
    [Topic.NOTIFICATION_AGENT_NEW_SENT]: agentNew_sent_1.NotificationAgentNewSentEventType,
    [Topic.NOTIFICATION_AGENT_VIEW]: agentNotification_view_1.NotificationAgentNotificationViewEventType,
    [Topic.NOTIFICATION_AGENT_DELETE]: agentNotification_delete_1.NotificationAgentNotificationDeleteEventType,
    [Topic.NOTIFICATION_AGENT_EDIT]: agentNotification_edit_1.NotificationAgentNotificationEditEventType,
    [Topic.NOTIFICATION_AGENT_TOGGLE_VISIBILITY]: agentNotification_toggleVisibility_1.NotificationAgentNotificationToggleVisibilityEventType,
    [Topic.NOTIFICATION_AGENT_RELAUNCH]: agentNotification_relaunch_1.NotificationAgentNotificationRelaunchEventType,
    [Topic.NOTIFICATION_AGENT_SEARCH_FILTERS]: agentNotification_searchFilters_1.NotificationAgentNotificationSearchFiltersEventType,
    [Topic.NOTIFICATION_AGENT_DATA_EXPORT]: agentNotification_data_export_1.NotificationAgentNotificationDataExportEventType,
    [Topic.NOTIFICATION_AGENT_DATA_READ]: agentNotification_data_read_1.NotificationAgentNotificationDataReadEventType,
    [Topic.HUB_CARD_VIEW]: hub_card_view_1.HubCardViewEventType,
    [Topic.FEEDBACK_COMMENT]: comment_2.FeedbackCommentEventType,
    [Topic.PUBLIC_CONTENT_READ]: content_read_1.PublicContentReadEventType,
    [Topic.PUBLIC_CASE_READ]: case_read_1.PublicCaseReadEventType,
    [Topic.PUBLIC_CONTENT_SATISFACTION]: content_satisfaction_1.PublicContentSatisfactionEventType,
    [Topic.PUBLIC_CONTENT_FEEDBACK]: content_feedback_1.PublicContentFeedbackEventType,
    [Topic.PUBLIC_CONTENT_SEARCH]: content_search_1.PublicContentSearchEventType,
    [Topic.PUBLIC_CONTENT_SEARCH_SUCCESS]: content_search_success_1.PublicContentSearchSuccessEventType,
    [Topic.PUBLIC_CONTENT_SEARCH_ABORT]: content_search_abort_1.PublicContentSearchAbortEventType,
    [Topic.PUBLIC_KNOWLEDGE_READ]: knowledge_read_1.PublicKnowledgeReadType,
    [Topic.PUBLIC_API_CONTENT_GET_SUCCESS]: content_get_success_1.PublicApiContenGetSuccessEventType,
    [Topic.PUBLIC_API_SEARCH_SUCCESS]: search_success_2.PublicApiSearchSuccessEventType,
    [Topic.PUBLIC_API_SEARCH_FAILURE]: search_failure_1.PublicApiSearchFailureEventType,
    [Topic.THREAD_MESSAGE_CREATE]: message_create_1.ThreadMessageCreateEventType,
    [Topic.THREAD_MESSAGE_EDIT]: message_edit_1.ThreadMessageEditEventType,
    [Topic.THREAD_MESSAGE_DELETE]: message_delete_1.ThreadMessageDeleteEventType,
    [Topic.THREAD_MESSAGE_VOTE]: message_vote_1.ThreadMessageVoteEventType,
    [Topic.THREAD_STATUS]: status_2.ThreadStatusEventType,
    [Topic.SLACK_SHORTCUT]: shortcut_1.SlackShortcutEventType,
    [Topic.SLACK_MODAL_ACTION]: modal_action_1.SlackModalActionEventType,
    [Topic.SETTINGS_ADD]: preference_add_1.SettingsPreferenceAddEventType,
    [Topic.SETTINGS_REMOVE]: preference_remove_1.SettingsPreferenceRemoveEventType,
    [Topic.SETTINGS_LANGUAGE]: language_1.SettingsLanguageEventType,
    [Topic.PUBLIC_SETTINGS_ADD]: public_add_1.PublicSettingsAddEventType,
    [Topic.PUBLIC_SETTINGS_UPDATE]: public_update_1.PublicSettingsUpdateEventType,
    [Topic.PUBLIC_SETTINGS_REMOVE]: public_remove_1.PublicSettingsRemoveEventType,
    [Topic.PUBLIC_SETTINGS_DEPLOYMENT_START]: public_deployment_start_1.PublicSettingsDeploymentStartEventType,
    [Topic.ASK_QUESTION]: question_2.AskQuestionEventType,
    [Topic.ASK_ANSWER]: answer_2.AskAnswerEventType,
    [Topic.ASK_USE_SOURCE]: useSource_2.AskUseSourceEventType,
    [Topic.ASK_COPY_ANSWER]: copyAnswer_2.AskCopyAnswerEventType,
    [Topic.ASK_FEEDBACK]: feedback_4.AskFeedbackEventType,
    [Topic.ASK_ERROR]: error_2.AskErrorEventType,
    [Topic.PUBLIC_ASK_QUESTION]: question_1.PublicAskQuestionEventType,
    [Topic.PUBLIC_ASK_ANSWER]: answer_1.PublicAskAnswerEventType,
    [Topic.PUBLIC_ASK_USE_SOURCE]: useSource_1.PublicAskUseSourceEventType,
    [Topic.PUBLIC_ASK_COPY_ANSWER]: copyAnswer_1.PublicAskCopyAnswerEventType,
    [Topic.PUBLIC_ASK_FEEDBACK]: feedback_3.PublicAskFeedbackEventType,
    [Topic.PUBLIC_ASK_ERROR]: error_1.PublicAskErrorEventType,
    [Topic.PUBLIC_ASK_OPEN_MODAL]: openModal_1.PublicAskOpenModalEventType,
    [Topic.PUBLIC_ASK_CLICK_EXTERNAL_LINK]: externalLink_1.PublicAskClickExternalLinkEventType,
    [Topic.OBSOLESCENCE_ALERTS]: alerts_1.ObsolescenceAlertsEventType,
    [Topic.LANGUAGE_SWITCH]: language_switch_1.AppLanguageSwitchEventType,
    [Topic.CONTEXT_FUNCTION_PERFORMANCE]: function_performance_1.FunctionPerformanceEventType,
    [Topic.CONTEXT_FUNCTION_ERROR]: function_error_1.FunctionErrorEventType,
    [Topic.PUBLIC_LOGIN_SUCCESS]: login_success_3.PublicLoginSuccessEventType,
    [Topic.PUBLIC_LOGIN_FAILURE]: login_failure_3.PublicLoginFailureEventType,
    [Topic.CUSTOM_FEEDBACK]: custom_1.CustomFeedbackEventType,
    // ACADEMY
    [Topic.ACADEMY_MODULE_VIEW]: module_view_1.AcademyModuleViewEventType,
    [Topic.ACADEMY_MODULE_SEARCH]: module_search_1.AcademyModuleSearchEventType,
    [Topic.ACADEMY_MODULE_START]: module_start_1.AcademyModuleStartEventType,
    [Topic.ACADEMY_MODULE_RESUME]: module_resume_1.AcademyModuleResumeEventType,
    [Topic.ACADEMY_MODULE_COMPLETE]: module_complete_1.AcademyModuleCompleteEventType,
    [Topic.ACADEMY_SLIDE_VIEW]: slide_view_1.AcademySlideViewEventType,
    [Topic.ACADEMY_SLIDE_NEXT]: slide_next_1.AcademySlideNextEventType,
    [Topic.ACADEMY_QUESTION_ANSWER]: question_answer_1.AcademyQuestionAnswerEventType,
    [Topic.ACADEMY_CORRECTION_VIEW]: correction_view_1.AcademyCorrectionViewEventType,
    [Topic.ACADEMY_MODULE_SATISFACTION]: module_satisfaction_1.AcademyModuleSatisfactionEventType,
    [Topic.ACADEMY_FEEDBACK]: feedback_5.AcademyFeedbackEventType,
    [Topic.ACADEMY_ANALYTICS_VIEW]: analytics_view_1.AcademyAnalyticsViewEventType,
    [Topic.ACADEMY_ANALYTICS_FILTERS]: analytics_filters_1.AcademyAnalyticsFiltersEventType,
    [Topic.ACADEMY_ANALYTICS_EXPORT]: analytics_export_1.AcademyAnalyticsExportEventType,
    // COPILOT
    [Topic.COPILOT_OPEN]: open_1.CopilotOpenEventType,
    [Topic.COPILOT_CLOSE]: close_1.CopilotCloseEventType,
    [Topic.COPILOT_TOAST_OPEN]: toast_open_1.CopilotToastOpenEventType,
    [Topic.COPILOT_TOAST_RECEIVE]: toast_receive_2.CopilotToastReceiveEventType,
    [Topic.COPILOT_GOTO_FEEDBACK]: goto_feedback_1.CopilotGoToFeedbackEventType,
    [Topic.COPILOT_GOTO_SEARCH]: goto_search_1.CopilotGoToSearchEventType,
    [Topic.COPILOT_COPY_TICKET_ID]: copy_ticketId_1.CopilotCopyTicketIdEventType,
    [Topic.COPILOT_USE_AUTOMATION]: use_automation_1.CopilotUseAutomationEventType,
    [Topic.COPILOT_AUTOMATION_RECEIVE]: automation_receive_1.CopilotAutomationReceiveEventType,
    [Topic.COPILOT_AUTOMATION_BRAIN_RECEIVE]: automation_brain_receive_1.CopilotAutomationBrainReceiveEventType,
    //ARCHIVES
    [Topic.ARCHIVE_DELETED]: archive_delete_1.ArchiveDeleteEventType,
    [Topic.ARCHIVE_RESTORED]: archive_restore_1.ArchiveRestoreEventType,
    [Topic.ARCHIVE_FILTERED]: archive_filter_1.ArchiveFilterEventType,
    //VERSION
    [Topic.VERSION_CREATE_DONE]: creation_done_1.VersionCreationDoneEventType,
    [Topic.VERSION_CREATE_REVIEW]: creation_review_1.VersionCreationReviewEventType,
    [Topic.VERSION_CREATE_TRIGGER]: creation_trigger_1.VersionCreationTriggerEventType,
    [Topic.VERSION_CREATE_OPEN_MODAL]: creation_open_modal_1.VersionCreationOpenModalEventType,
    [Topic.VERSION_UPDATE_AVAILABLE]: update_available_1.VersionUpdateAvailableEventType,
    [Topic.VERSION_UPDATE_OPEN_MODAL]: update_open_modal_1.VersionUpdateOpenModalEventType,
    [Topic.VERSION_UPDATE_TRIGGER]: update_trigger_1.VersionUpdateTriggerEventType,
    [Topic.VERSION_UPDATE_HIDE_BANNER]: update_hide_banner_1.VersionUpdateHideBannerEventType,
    // ASK CUSTOM ASSISTANT
    [Topic.ASK_CUSTOM_ASSISTANT_ACCESS_SETTINGS_AI]: access_settings_ai_1.AskCustomAssistantAccessSettingsAiEventType,
    [Topic.ASK_CUSTOM_ASSISTANT_ACCESS_SETTINGS_ASK]: access_settings_ask_1.AskCustomAssistantAccessSettingsAskEventType,
    [Topic.ASK_CUSTOM_ASSISTANT_CREATE]: create_2.AskCustomAssistantCreateEventType,
    [Topic.ASK_CUSTOM_ASSISTANT_UPDATE]: update_2.AskCustomAssistantUpdateEventType,
    [Topic.ASK_CUSTOM_ASSISTANT_TRIGGER_CONFIGURE]: trigger_configure_1.AskCustomAssistantTriggerConfigureEventType,
    [Topic.ASK_CUSTOM_ASSISTANT_TRIGGER_EDIT]: trigger_edit_1.AskCustomAssistantTriggerEditEventType,
    [Topic.ASK_CUSTOM_ASSISTANT_TRIGGER_START]: trigger_start_1.AskCustomAssistantTriggerStartEventType,
    [Topic.ASK_CUSTOM_ASSISTANT_TRIGGER_TESTER]: trigger_tester_1.AskCustomAssistantTriggerTesterEventType,
    // HUB
    [Topic.HUB_ARCHIVE_OPEN]: open_2.HubArchiveOpenType,
    [Topic.HUB_ARCHIVE_CLOSE]: close_2.HubArchiveCloseType,
    [Topic.HUB_TASK_OPEN]: open_3.HubTaskOpenEventType,
    [Topic.HUB_TASK_CLOSE]: close_3.HubTaskCloseEventType,
    [Topic.HUB_TASK_ARCHIVE]: archive_2.HubTaskArchiveEventType,
    [Topic.HUB_TASK_RESTORE]: restore_1.HubTaskRestoreEventType,
    [Topic.HUB_TASK_STATUS]: status_3.HubTaskStatusEventType,
    [Topic.HUB_TASK_UPVOTE_ADD]: add_1.HubTaskAddUpvoteEventType,
    [Topic.HUB_TASK_UPVOTE_REMOVE]: remove_1.HubTaskRemoveUpvoteEventType,
    [Topic.HUB_TASK_RATING_UPDATE]: update_3.HubTaskUpdateRatingEventType,
    [Topic.HUB_TASK_RATING_REMOVE]: remove_2.HubTaskRemoveRatingEventType,
    [Topic.HUB_TASK_ASSIGNEE]: assignee_1.HubTaskAssigneeEventType,
    [Topic.HUB_TASK_PRIORITY_UPDATE]: priority_update_1.HubTaskUpdatePriorityEventType,
    [Topic.HUB_TASK_PRIORITY_REMOVE]: priority_remove_1.HubTaskRemovePriorityEventType,
    [Topic.HUB_TASK_DEADLINE_UPDATE]: deadline_update_1.HubTaskUpdateDeadlineEventType,
    [Topic.HUB_TASK_DEADLINE_REMOVE]: deadline_remove_1.HubTaskRemoveDeadlineEventType,
    [Topic.HUB_TASK_COMMENT_ADD]: add_2.HubTaskAddCommentEventType,
    [Topic.HUB_TASK_COMMENT_REMOVE]: remove_3.HubTaskRemoveCommentEventType,
    [Topic.HUB_TASK_COMMENT_UPDATE]: update_4.HubTaskUpdateCommentEventType,
    [Topic.HUB_VIEW_SELECT]: select_1.HubViewSelectEventType,
    [Topic.HUB_FILTERS_SEARCH]: search_2.HubFiltersSearchEventType,
    [Topic.HUB_FILTERS_UPDATE]: update_5.HubFiltersUpdateEventType,
    [Topic.HUB_FILTERS_RESET]: reset_1.HubFiltersResetEventType,
    // SESSION
    [Topic.CONTEXT_SESSION_WORKFLOW_ACTION]: session_workflowAction_1.ContextSessionWorkflowActionEventType,
    // AI EDITOR ASSIST
    [Topic.AI_EDITOR_ASSIST_TRIGGER]: trigger_1.aiEditorAssistTriggerEventType,
    [Topic.AI_EDITOR_ASSIST_USE_SUGGESTION]: use_suggestion_1.aiEditorAssistUseSuggestionEventType,
    [Topic.AI_EDITOR_ASSIST_CANCEL_SUGGESTION]: cancel_suggestion_1.aiEditorAssistCancelSuggestionEventType,
};
exports.VERSION = "0.1.154";
const createEventType = (T) => t.intersection([
    t.type({
        origin: t.string,
        topic: t.string,
        event: T,
    }),
    t.partial({ url: t.string }),
]);
exports.createEventType = createEventType;
